import { DataFormClient } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const sponsorDataForm: DataFormClient = {
  SponsorName: "",
  Code: "",
  Img: "",
  id: "",
  clientId: "",
};
